<template>
  <b-container class="search-area" fluid="lg">
    <div class="mb-3">
      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Tutor</h3>
          <TutorInput v-model="conditions.tutor" />
        </b-col>
        <b-col>
          <h3 class="common__search-title">University</h3>
          <UniversityInput v-model="conditions.university" />
        </b-col>
        <b-col>
          <template v-if="conditions.university">
            <h3 class="common__search-title">Campus</h3>
            <CampusesInput
              v-model="conditions.campuses"
              :belongsToUniversity="conditions.university"
            />
          </template>
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col cols="8">
          <h3 class="common__search-title">Day of the Week</h3>
          <WeekdaysInput v-model="conditions.weekdays" />
        </b-col>
        <b-col>
          <h3 class="common__search-title">Academic Year/Semester</h3>
          <FiscalYearSemesterInput v-model="conditions.fiscalYearSemester" />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Period</h3>
          <PeriodsInput v-model="conditions.periods" />
        </b-col>
        <b-col cols="4">
          <h3 class="common__search-title">Quarter</h3>
          <input type="text" v-model="conditions.quarter" />
        </b-col>
      </b-form-row>
    </div>

    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash';
import TutorInput from '@/components/parts/inputItem/SearchTutor.vue'
import UniversityInput from '@/components/parts/inputItem/SelectUniversityInput.vue'
import CampusesInput from '@/components/parts/inputItem/CampusesInput.vue'
import WeekdaysInput from '@/components/parts/inputItem/WeekdaysInput.vue'
import PeriodsInput from '@/components/parts/inputItem/PeriodsInput.vue'
import FiscalYearSemesterInput from '@/components/parts/inputItem/FiscalYearSemesterInput.vue'
import { GroupConditions } from '@/store/groups/types'

// 検索の初期設定値
const initialConditions: GroupConditions = {
  tutor: null,
  university: null,
  campuses: [],
  weekdays: [],
  periods: [],
  fiscalYearSemester: null,
  quarter: null,
}

export default Vue.extend({
  components: {
    TutorInput,
    UniversityInput,
    CampusesInput,
    WeekdaysInput,
    PeriodsInput,
    FiscalYearSemesterInput,
  },

  data() {
    return {
      conditions: _.cloneDeep(initialConditions),
    }
  },

  methods: {
    search() {
      // 検索ボタン押した場合
      this.changeConditions()
    },
    reset() {
      // リセットボタン押した場合
      this.conditions = _.cloneDeep(initialConditions)
      this.changeConditions()
    },
    changeConditions() {
      this.$emit('changeConditions', this.conditions)
    },
  },
  created() {
    this.changeConditions()
  },
})

</script>

<style scoped>
.search-list {
  background: #DDEAF6;
  padding: 20px;
}

.d-flex {
  display: flex;
}

.search-box {
  margin-bottom:20px;
}

.search-content {
  margin-right: 20px;
}

.search-item {
  margin-bottom: 10px;
  font-size: 15px;
}

.button-list {
  display: flex;
  justify-content: flex-end;
}

input[type="text"], select{
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 200px;
}

.campus-title {
  margin-bottom: 18px;
}
</style>
